'use client';

import { c as _c } from "react/compiler-runtime";
import { type Spacing, getOuterSpacingClassNames } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import { type HeroBannerInputProps } from './HeroBanner.builder';
import { HeroMedia } from './HeroMedia';
export const HeroBanner = t0 => {
  const $ = _c(18);
  const {
    backgroundColor,
    mediaLandscape,
    mediaLandscapeAlt,
    mediaLandscapeBlur,
    mediaPortrait,
    mediaPortraitAlt,
    mediaPortraitBlur,
    children,
    outerSpacing
  } = t0;
  let t1;
  if ($[0] !== outerSpacing) {
    t1 = cn("relative flex h-screen items-end overflow-hidden md:h-[630px] md:w-full md:items-center", getOuterSpacingClassNames(outerSpacing));
    $[0] = outerSpacing;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== backgroundColor) {
    t2 = {
      backgroundColor
    };
    $[2] = backgroundColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== mediaLandscape || $[5] !== mediaLandscapeAlt || $[6] !== mediaLandscapeBlur || $[7] !== mediaPortrait || $[8] !== mediaPortraitAlt || $[9] !== mediaPortraitBlur) {
    t3 = (mediaPortrait || mediaLandscape) && <><HeroMedia className="block object-cover lg:hidden" src={mediaPortrait || mediaLandscape} alt={mediaPortraitAlt || mediaLandscapeAlt} blurDataURL={mediaPortraitBlur || mediaLandscapeBlur} /><HeroMedia className="hidden object-cover lg:block" src={mediaLandscape || mediaPortrait} alt={mediaLandscapeAlt || mediaPortraitAlt} blurDataURL={mediaLandscapeBlur || mediaPortraitBlur} /></>;
    $[4] = mediaLandscape;
    $[5] = mediaLandscapeAlt;
    $[6] = mediaLandscapeBlur;
    $[7] = mediaPortrait;
    $[8] = mediaPortraitAlt;
    $[9] = mediaPortraitBlur;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="absolute inset-0 bg-bodi-black" style={t2}>{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== children || $[15] !== t1 || $[16] !== t4) {
    t5 = <div className={t1}>{t4}{children}</div>;
    $[14] = children;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};